import React, { useRef, useState } from "react";

// Product image with magnify-on-hover. On desktop, hovering zooms into the
// point under the cursor; on touch it just shows the image normally.
export default function ZoomImage({ src, alt = "", className = "", zoom = 2 }) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 50, y: 50 });
  const [on, setOn] = useState(false);

  const move = (e) => {
    const r = ref.current.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;
    setPos({ x: Math.max(0, Math.min(100, x)), y: Math.max(0, Math.min(100, y)) });
  };

  return (
    <div
      ref={ref}
      onMouseEnter={() => setOn(true)}
      onMouseLeave={() => setOn(false)}
      onMouseMove={move}
      className={`relative overflow-hidden cursor-zoom-in ${className}`}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover transition-transform duration-200 will-change-transform"
        style={on ? { transform: `scale(${zoom})`, transformOrigin: `${pos.x}% ${pos.y}%` } : undefined}
        draggable={false}
      />
    </div>
  );
}
